import { observer } from 'mobx-react';
import { t } from 'i18next';
import { Button, Flex, ScrollArea, Table } from '@mantine/core';
import React, { Dispatch, SetStateAction, useEffect } from 'react';
import SurveyCategoriesRow from './SurveyCategoriesRow.tsx';
import { IQuestionScore } from '../../../global/entities/Questionnaires/Questionnaires.ts';
import { Th, useTable } from '../../../global/hooks/useTable.tsx';

export interface ISurveyCategoriesProps {
    scores: IQuestionScore[];
    onChangesScores: Dispatch<SetStateAction<IQuestionScore[]>>;
    showErrors: boolean;
}

let nextNegativeId = -1;

const SurveyCategories: React.FC<ISurveyCategoriesProps> = observer(({ scores, onChangesScores, showErrors }) => {
    const { setSorting, sortBy, reverseSortDirection, setSortedData, sortedData } = useTable();

    useEffect(() => {
        setSortedData([]);
        if (scores?.length) 
            setSortedData(scores);
        
    }, [scores]);

    const handleAddRow = () => {
        const newRow: IQuestionScore = {
            id: nextNegativeId--,
            questionName: '',
            categoryEn: '',
            categoryFr: '',
            scoring: '',
        };
        onChangesScores((prev) => [...prev, newRow]);
    };

    return (
        <>
            <ScrollArea>
                <Table verticalSpacing="xs">
                    <Table.Thead>
                        <Table.Tr>
                            <Th
                                sorted={sortBy === 'questionName'}
                                reversed={reverseSortDirection}
                                onSort={() => setSorting('questionName', sortedData)}
                            >
                                {t('table.survey.questionName')}
                            </Th>

                            <Th
                                sorted={sortBy === 'categoryFr'}
                                reversed={reverseSortDirection}
                                onSort={() => setSorting('categoryFr', sortedData)}
                            >
                                {t('table.survey.categoryFr')}
                            </Th>
                            <Th
                                sorted={sortBy === 'categoryEn'}
                                reversed={reverseSortDirection}
                                onSort={() => setSorting('categoryEn', sortedData)}
                            >
                                {t('table.survey.categoryEn')}
                            </Th>
                            <Th
                                sorted={sortBy === 'scoring'}
                                reversed={reverseSortDirection}
                                onSort={() => setSorting('scoring', sortedData)}
                            >
                                {t('table.survey.scoring')}
                            </Th>
                            <Table.Th></Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {sortedData?.map((question: IQuestionScore, index: number) => (
                            <SurveyCategoriesRow
                                key={index}
                                question={question}
                                index={index}
                                onChangesScores={onChangesScores}
                                showErrors={showErrors}
                            />
                        ))}
                    </Table.Tbody>
                </Table>
            </ScrollArea>

            <Flex justify="flex-end" mt="md">
                <Button m={'sm'} onClick={handleAddRow}>
                    {t('button.add')}
                </Button>
            </Flex>
        </>
    );
});

export default SurveyCategories;
